import { useState } from "react";
import { Label, Tag, Text as KonvaText, Rect } from "react-konva";

type AnnotationBBoxProps = {
  bbox: number[];
  downscalePoint: (x: number, y: number) => [number, number];
  stroke: string;
  fill: string;
  type: string;
};

export function AnnotationBBox({
  bbox,
  downscalePoint,
  stroke = "red",
  fill = "rgba(255, 0, 0, 0.3)",
  type,
}: AnnotationBBoxProps) {
  const [hovered, setHovered] = useState(false);
  const [x1, y1] = downscalePoint(bbox[0], bbox[1]);
  const [x2, y2] = downscalePoint(bbox[2], bbox[3]);
  const w = x2 - x1;
  const h = y2 - y1;

  return (
    <>
      {hovered && (
        <Label x={x1} y={y1 - 28}>
          <Tag fill={stroke} />
          <KonvaText
            text={`${type}`}
            fontFamily="Arial"
            fontSize={14}
            padding={5}
            fill="black"
            fontStyle="bold"
          />
        </Label>
      )}
      <Rect
        x={x1}
        y={y1}
        width={w}
        height={h}
        stroke={stroke}
        strokeWidth={hovered ? 4 : 2}
        fill={hovered ? undefined : fill}
        onPointerEnter={() => {
          setHovered(true);
        }}
        onPointerLeave={() => {
          setHovered(false);
        }}
      />
    </>
  );
}
